export const KEYWORD_SWITCH_SOURCE_HANDLES = {
  match1: 'keyword-switch-match-1',
  match2: 'keyword-switch-match-2',
  default: 'keyword-switch-default',
} as const;
